import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addLocation } from "../../redux/actions/location/addLocationAction";
import styles from "../productCategory/AddProdCat.module.css";

const AddLocation = ({ onSuccess = null, inModal = false, onCancel = null, initialName = "" }) => {
  const dispatch = useDispatch();
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialName && form) {
      form.setFieldsValue({ name: initialName });
    }
  }, [initialName, form]);

  const onFinish = async (values) => {
    try {
      const resp = await dispatch(addLocation(values));
      if (resp?.message === "success") {
        setLoading(false);
        form.resetFields();
        if (onSuccess) onSuccess(resp.data);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const formContent = (
    <Form
      form={form}
      name="addLocation"
      labelCol={{ span: inModal ? 6 : 7 }}
      wrapperCol={{ span: inModal ? 18 : 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        style={{ marginBottom: "10px" }}
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please enter location name!" }]}
      >
        <Input placeholder="e.g. Main Warehouse" />
      </Form.Item>
      <Form.Item
        style={{
          marginBottom: "10px",
          ...(inModal && { marginBottom: 0 }),
        }}
        className={!inModal ? styles.addProdCatBtnContainer : undefined}
        wrapperCol={inModal ? { offset: 0, span: 24 } : undefined}
      >
        {inModal ? (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, width: "100%" }}>
            <Button
              loading={loading}
              onClick={() => setLoading(true)}
              htmlType="submit"
              shape="round"
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
              block={!onCancel}
            >
              Add Location
            </Button>
            {onCancel && (
              <Button
                type="primary"
                danger
                shape="round"
                onClick={onCancel}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        ) : (
          <>
            <Button
              loading={loading}
              onClick={() => setLoading(true)}
              type="primary"
              htmlType="submit"
              shape="round"
            >
              Add Location
            </Button>
            {onCancel && (
              <Button style={{ marginLeft: 8 }} onClick={onCancel}>
                Cancel
              </Button>
            )}
          </>
        )}
      </Form.Item>
    </Form>
  );

  if (inModal) {
    return formContent;
  }

  return (
    <Fragment>
      <Row className="mr-top" gutter={[0, 30]}>
        <Col xs={24} sm={24} md={24} lg={11} xl={11} className="rounded column-design">
          <Card bordered={false} className="criclebox h-full">
            <Title
              level={4}
              className="text-center"
              style={{ backgroundColor: "#dadada", padding: "10px", margin: "0 !important" }}
            >
              Add Location
            </Title>
            {formContent}
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AddLocation;
